import { getStore } from "store/store";

import { FLOWABLE_DESIGN_URL } from "../config";
import { compileDataTable, decompileDataTable } from "./utils/advancedBuilderUtils";

const getTokenSilently = () => {
	return getStore().then(store => {
		//todo: move to own redux spot
		const token = store.getState().shell?.cayuseHeader?.authenticationToken;
		if (token) {
			return Promise.resolve(token);
		} else {
			return Promise.reject(new Error("no token"));
		}
	});
};

const angularHttpInterceptor = () => {
	return {
		request: function (config) {
			config.data = compileDataTable(config);
			// don't intercept ui-grid, somebody else is doing that as well
			if (config.url.startsWith("ui-grid/")) {
				return config;
			}
			if (!config.url.startsWith(FLOWABLE_DESIGN_URL)) {
				let prefix = FLOWABLE_DESIGN_URL;
				if (!config.url.startsWith("/")) {
					prefix += "/";
				}
				config.url = prefix + config.url;
			}

			return getTokenSilently()
				.then(token => {
					config.headers.Authorization = "Bearer " + token;

					return config;
				});
		},
		response: function (response) {
			decompileDataTable(response);
			return response;
		}
	};
};

export default angularHttpInterceptor;
